import ContinentCountriesList from './ContinentCountriesList';
export default ContinentCountriesList;



// WEBPACK FOOTER //
// ./src/components/Continent/ContinentCountries/ContinentCountriesList/index.js